module.exports = __webpack_public_path__ + "img/1970East-016_WEB-min.f83f19b7.jpg";